module.exports = __webpack_public_path__ + "static/media/panda-partners-3.0b869abf.svg";